import { render, staticRenderFns } from "./exts.vue?vue&type=template&id=30dbb299&scoped=true&"
import script from "./exts.vue?vue&type=script&lang=js&"
export * from "./exts.vue?vue&type=script&lang=js&"
import style0 from "./exts.vue?vue&type=style&index=0&id=30dbb299&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dbb299",
  null
  
)

export default component.exports